import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Area } from '../../../models/area';
import { ActivatedRoute } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { distinctUntilChanged, map } from 'rxjs';
import { findAreaAct, saveAreaAct, updateAreaAct } from '../../../store/area/area.actions';

@Component({
  selector: 'app-areas-detail',
  standalone: false,
  templateUrl: './areas-detail.component.html',
  styleUrl: './areas-detail.component.css'
})
export class AreasDetailComponent implements OnInit{

  areaForm!: NgForm;
  loading = false;
  title!: string;
  area: Area = new Area();
  violations: any;

  constructor(
    private route: ActivatedRoute,
    private areaStore: Store<{areaRdc: any}>
  ) {
    this.areaStore.pipe(
      select('areaRdc'),
      map(state => ({ // filtra cuando cambian las propiedades que se usan en este componente
        //divisions: state.divisions,
        //areas: state.areas,
        area: state.area,
        violations: state.violations,
        loading: state.loading
      })),
      // evita repeticiones
      distinctUntilChanged((prev, curr) =>
        JSON.stringify(prev) === JSON.stringify(curr)
      )
    ).subscribe(({ area, violations, loading }) => {
      this.area = JSON.parse(JSON.stringify(area));
      this.violations = violations;
      this.loading = loading;
      this.title = 'Detalles de Area';

      if(this.areaForm){
      
        Object.keys(this.areaForm.controls).forEach(controlName => {
          const control = this.areaForm.controls[controlName];
          if (this.violations[controlName]) {
            control.setErrors({ backend: true }); // Marca error
          }
        });
      }

    });

  }

  ngOnInit(): void {

    this.route.paramMap.subscribe(params => {
      const id: number = + (params.get('id') || '0');
      if(id > 0){
        this.areaStore.dispatch(findAreaAct({ id }));
      }else{
        this.area = new Area();
        this.area.active = true;
        this.loading = false;
        this.title = 'Agregar Area';
      }
    });

  }

  onSubmitArea(areaForm: NgForm): void {
    //this.loading = true;
    this.areaForm = areaForm;
    const areaCopy = JSON.parse(JSON.stringify(this.area));
   
    if (areaCopy.id > 0) {
      this.areaStore.dispatch(updateAreaAct({ areaUpdated: areaCopy }))
    } else {
      this.areaStore.dispatch(saveAreaAct({ areaNew: areaCopy }))
    }
  }

}
